import './Anchor.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Anchor = ({ className, href, target, onClick, children }) => {
	return (
		<a className={`react__anchor ${className}`} href={href} target={target} onClick={e => onClick(e)}>
			{children}
		</a>
	);
};

Anchor.propTypes = {
	target: PropTypes.oneOf(['_self', '_blank']),
	href: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node
};

Anchor.defaultProps = {
	target: '_self',
	href: '#',
	onClick: () => {},
	children: null,
	className: ''
};

export default Anchor;
